<template>
  <div class="topic-page">
    <div class="topic-page-navigate position-relative">
      <video src="../../assets/source/bg-video.mp4" muted loop autoplay />
      <div class="topic-page-navigate-body position-relative">
        <div class="topic-page-navigate-body-content safe-with flex-row-center-between">
          <p class="font-bold font-36 font-color-fff tit">特色专题</p>
        </div>
      </div>
    </div>
    <div class="topic-page-list">
      <div class="topic-page-list-body">
        <div v-if="1" class="topic-page-list-body-content flex">
          <div v-for="(item, index) in topics" :key="index" class="topic-page-list-body-item position-relative" @click="toDetail(item)">
            <el-image class="img" :src="item.coverImage" fit="fill">
              <div slot="placeholder" class="image-slot">
                <img class="match-height match-width" src="../../assets/img/icon-default.jpg">
              </div>
              <div slot="error" class="image-slot">
                <img class="match-height match-width" src="../../assets/img/icon-default.jpg">
              </div>
            </el-image>
            <div class="topic-page-list-body-item-title flex-row-center">
              <p class="text-line-1">{{ item.title }}</p>
            </div>
          </div>
        </div>
        <div class="topic-page-list-body-page flex-center">
          <el-pagination
            background
            :current-page="curPage"
            :page-size="10"
            layout="prev, pager, next"
            :total="pages"
            @current-change="pageChage"
          />
        </div>
        <div v-if="requestError" class="topic-page-list-body-error flex-column-center">
          <p class="font-14 font-color-999">暂无专题数据</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/index.js'
import { getShowPath } from '@/utils/imgpath.js'
export default {
  data() {
    return {
      requestError: false,
      pages: 0,
      curPage: 1,
      topics: []
    }
  },
  watch: {
    $route(to, from) {
      window.scrollTo(0, 0)
      this.curPage = this.$route.query.page ?? 1
      this.request()
    }
  },
  mounted() {
    this.request()
    this.curPage = this.$route.query.page ?? 1
  },
  methods: {
    request() {
      api.topicList({
        asc: 0,
        field: 'publishTime',
        status: 1,
        rangeQuery: 1,
        page: this.curPage,
        limit: 20
      }).then(r => {
        if (r.code === 2000) {
          r.items.data.forEach(v => {
            v.coverImage = getShowPath('img', v.coverImage)
          })
          this.topics = r.items.data
          this.pages = r.items.totalCount
        }
      })
    },
    pageChage(v) {
      this.$router.push({
        path: '/topic',
        query: {
          page: v
        }
      })
    },
    toDetail(v) {
      const page = this.$router.resolve({
        path: '/topic/info',
        query: {
          id: v.id
        }
      })
      window.open(page.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
 /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
   background-color: #B21F12;
 }

 /deep/.el-pagination.is-background .btn-prev {
   min-width: 40px;
   border-radius: 5px;
 }

 /deep/.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev {
   min-width: 40px;
   border-radius: 5px;
 }
 /deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
   color: #B21F12;
 }
 /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
   color: #fff;
 }

 /deep/.el-pagination.is-background .el-pager li.active {
   border: none;
 }

 /deep/.el-pagination.is-background .el-pager li {
   min-width: 40px !important;
   background-color: #fff;
   border: 1px solid #F7F7F7;
 }
</style>

<style scoped>
.topic-page-navigate {
    background-image: url('../../assets/img/bg-notice-navigate.png');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    height: 200px;
    margin-top: -60px;
  }

  .topic-page-navigate video {
    width: 100%;
    height: 100%;
    object-fit: fill;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }

  .topic-page-navigate-body {
    height: 200px;
    z-index: 1;
  }

  .topic-page-navigate-body-content {
    padding-top: 120px;
  }

  .topic-page-navigate-body-content .tit {
    line-height: 80px;

  }

  .topic-page-navigate-body-content .search {
    width: 300px;
    height: 40px;
    background: rgba(0, 0, 0, 0.15);
    border-radius: 5px;
    padding: 0 10px;
  }

  .topic-page-navigate-body-content .search img {
    margin-left: 10px;
  }

  .topic-page-navigate-body-content .search input {
    outline: none;
    height: 100%;
    border: none;
    background-color: rgba(0, 0, 0, 0);
    color: #fff;
  }

  .topic-page-navigate-body-content .search input::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }

  .topic-page-list-body {
    width: 1220px;
    margin: 0 auto;
    padding-top: 40px;
  }

  .topic-page-list-body-content {
    flex-wrap: wrap;
  }

  .topic-page-list-body-item {
    width: 290px;
    height: 380px;
    margin-right: 20px;
    margin-bottom: 20px;
    border-radius: 5px;
    overflow: hidden;
  }

  .topic-page-list-body-item .img {
    width: 100%;
    height: 100%;
    transition: 400ms;
  }

  .topic-page-list-body-item .img:hover {
    transform: scale(1.08);
  }

  .topic-page-list-body-item:nth-child(4n) {
    margin-right: 0;
  }

  .topic-page-list-body-item-title {
    position: absolute;
    padding: 0 14px;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
    background: linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
  }

  .topic-page-list-body-item-title p {
    color: #fff;
    font-size: 14px;
  }

  .topic-page-list-body-error {
    width: 100%;
    height: 400px;
    padding-top: 150px;
  }

  .topic-page-list-body-page {
    margin: 10px 0 60px;
  }
</style>
